import type { LoggerService } from '../LoggerService'

export function mountLifecycleInterceptor(logger: LoggerService): () => void {
  const onOnline = () =>
    logger.track('system.connectivity_changed', { online: true })
  const onOffline = () =>
    logger.warn('system.connectivity_changed', { online: false })
  const onVisibility = () => {
    logger.debug('system.visibility_changed', {
      state: document.visibilityState
    })
    if (document.visibilityState === 'hidden') void logger.flush()
  }
  const onPageHide = (event: PageTransitionEvent) => {
    logger.endSession(event.persisted ? 'bfcache' : 'pagehide')
    void logger.flush()
  }
  const onPageShow = (event: PageTransitionEvent) => {
    if (event.persisted) logger.track('system.bfcache_restored', {})
  }

  window.addEventListener('online', onOnline)
  window.addEventListener('offline', onOffline)
  document.addEventListener('visibilitychange', onVisibility)
  window.addEventListener('pagehide', onPageHide)
  window.addEventListener('pageshow', onPageShow)
  return () => {
    window.removeEventListener('online', onOnline)
    window.removeEventListener('offline', onOffline)
    document.removeEventListener('visibilitychange', onVisibility)
    window.removeEventListener('pagehide', onPageHide)
    window.removeEventListener('pageshow', onPageShow)
  }
}
